export default "__VITE_ASSET__NRXXU1pY__"